/* Board list customization (2026-09, ported from the legacy PenumbraLynx
   favouriteBoards — that copy was dead in-tree: `return;` since upstream 2019
   and never included by any template). Behavior agreed with operator:
   - Fresh browser (localStorage untouched) shows the DEFAULT subset, rendered
     into .navLinkSpan[data-default-boards] by leftBar.njk from kohlnumbra.json.
   - Star toggle on board/thread pages (next to #labelName) and on every row of
     /boards.js. Toggling persists the full list to localStorage
     savedFavouriteBoards; nav then shows EXACTLY that list.
   - Unstar everything -> nav board links all hidden; the [+] all-boards link
     stays and is the way back (operator decision).
   - Both #topNav and #bottomNav carry a .navLinkSpan (leftBar.njk double
     include); both are filtered. Mobile burger is the same DOM, so one filter
     covers desktop + mobile. */
var favouriteBoards = {};

favouriteBoards.uriFromHref = function(href) {
  var m = /^\/([^/]+)\/$/.exec(href || '');
  return m ? m[1] : null;
};

favouriteBoards.getDefaults = function() {
  var nav = document.querySelector('.navLinkSpan[data-default-boards]');
  if (!nav) return [];
  return (nav.getAttribute('data-default-boards') || '').split(' ').filter(Boolean);
};

/* null from localStorage = never customized -> defaults. '[]' = user
   deliberately emptied the list -> empty (hides all nav board links). */
favouriteBoards.getList = function() {
  var raw = localStorage.getItem('savedFavouriteBoards');
  if (raw === null) return favouriteBoards.getDefaults().slice();
  try {
    return JSON.parse(raw || '[]');
  } catch (e) {
    return [];
  }
};

favouriteBoards.saveList = function(list) {
  localStorage.setItem('savedFavouriteBoards', JSON.stringify(list));
};

favouriteBoards.toggle = function(uri, button) {
  var raw = localStorage.getItem('savedFavouriteBoards');
  var list = (raw === null) ? favouriteBoards.getDefaults().slice() : JSON.parse(raw || '[]');
  var i = list.indexOf(uri);
  if (i > -1) {
    list.splice(i, 1);
  } else {
    list.push(uri);
  }
  favouriteBoards.saveList(list);
  // render() repaints nav filter + every star on this page. Stars exist by
  // now because init() creates them BEFORE the first render() — that order is
  // what makes initial color state and post-toggle color state agree.
  favouriteBoards.render();
};

favouriteBoards.starClass = function(uri) {
  return (favouriteBoards.getList().indexOf(uri) > -1) ? 'checkedFavouriteButton' : '';
};

favouriteBoards.makeStar = function(uri, withTitle) {
  var star = document.createElement('span');
  star.className = 'favouriteStar';
  if (withTitle) {
    star.title = 'Show/hide this board in the navbar';
  }
  star.setAttribute('data-board', uri);
  star.onclick = function(e) {
    e.preventDefault();
    e.stopPropagation();
    favouriteBoards.toggle(uri, star);
  };
  return star;
};

/* One pass: filter every .navLinkSpan board link, prune orphan separators,
   paint every star state. */
favouriteBoards.render = function() {
  var list = favouriteBoards.getList();

  document.querySelectorAll('.navLinkSpan').forEach(function(span) {
    var kids = Array.prototype.slice.call(span.children);
    var boardUri = function(el) { return el.tagName === 'A' ? favouriteBoards.uriFromHref(el.getAttribute('href')) : null; };

    // Pass 1: show/hide the board links themselves. The mobile minus lives
    // INSIDE its anchor, so hiding the link hides the minus with it.
    kids.forEach(function(el) {
      var uri = boardUri(el);
      if (uri !== null) { // [+] /boards.js and non-board links: always visible
        el.style.display = (list.indexOf(uri) > -1) ? '' : 'none';
      }
    });

    // Pass 2: separators. For each pair of ADJACENT visible boards, keep the
    // first '/' after the earlier board (the one physically in their gap);
    // hide every other separator. Anchoring to the pair — not to immediate
    // DOM neighbors — is what makes "bbw / gen" work when everything between
    // them is hidden. All-visible case keeps exactly the template's seps.
    var vis = kids.filter(function(el) { var u = boardUri(el); return u !== null && list.indexOf(u) > -1; });
    var keep = {};
    for (var v = 1; v < vis.length; v++) {
      var start = kids.indexOf(vis[v - 1]);
      for (var s = start + 1; s < kids.length; s++) {
        if (boardUri(kids[s]) !== null) break; // safety: hit a board, no sep in gap
        if (kids[s].classList && kids[s].classList.contains('navSep')) { keep[s] = true; break; }
      }
    }
    kids.forEach(function(el, i) {
      if (el.classList && el.classList.contains('navSep')) {
        el.style.display = keep[i] ? '' : 'none';
      }
    });
  });

  document.querySelectorAll('.favouriteStar').forEach(function(star) {
    // Decorative stars (the /boards.js hint line) carry no data-board: they are
    // lit by the class the template ships, and repainting them here would strip
    // checkedFavouriteButton and show an UNLIT star in a hint about lit stars.
    var uri = star.getAttribute('data-board');
    if (!uri) return;
    star.className = 'favouriteStar' + (favouriteBoards.starClass(uri) ? ' checkedFavouriteButton' : '');
  });
};

/* Board/thread pages: one star next to the board title (#labelName, in the
   h1 — same anchor the legacy code used). */
favouriteBoards.initBoardPage = function() {
  var label = document.getElementById('labelName');
  if (!label) return;
  // Board from the page's own location: /bbw/ or /bbw/res/N.html.
  var m = /^\/([^/]+)/.exec(window.location.pathname);
  if (!m) return;
  var uri = m[1];
  var h1 = label.closest('h1') || label.parentNode;
  h1.appendChild(favouriteBoards.makeStar(uri, true));
};

/* Mobile burger quick-remove (2026-09): a minus at the right end of each
   board row INSIDE its anchor (the opened mobile panel styles a as a flex
   row: name left, minus right). Hidden on desktop by CSS. preventDefault +
   stopPropagation keep the anchor from navigating and keep navBurger.js's
   close-on-tap from firing, so the panel stays open for more removals.
   render() hides it with its board (it's a child of the link). */
favouriteBoards.initNavRemove = function() {
  document.querySelectorAll('.navLinkSpan > a').forEach(function(el) {
    var uri = favouriteBoards.uriFromHref(el.getAttribute('href'));
    if (uri === null) return; // [+] and friends: no minus
    if (el.querySelector('.navRemove')) return; // already there
    var minus = document.createElement('span');
    minus.className = 'navRemove';
    minus.setAttribute('data-board', uri);
    minus.title = 'Remove from nav';
    minus.textContent = '\u2212';
    minus.onclick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      favouriteBoards.toggle(uri, minus);
    };
    el.appendChild(minus);
  });
};

/* /boards.js: one star per row, LEADING the board name (operator 2026-09:
   trailing felt wrong; leading puts every star in one straight column). */
favouriteBoards.initBoardsPage = function() {
  document.querySelectorAll('.boardsCell').forEach(function(cell) {
    var link = cell.querySelector('a.linkBoard');
    if (!link) return;
    var uri = favouriteBoards.uriFromHref(link.getAttribute('href'));
    if (!uri) return;
    var header = cell.querySelector('.boardsCellHeader') || cell;
    if (header.querySelector('.favouriteStar')) return; // already there
    header.insertBefore(favouriteBoards.makeStar(uri, true), link);
  });
};

favouriteBoards.init = function() {
  // Create the controls FIRST, then paint: render() colors each star by
  // whether its board is in the active list (defaults on a fresh browser),
  // filters the nav, and shows/hides each mobile minus with its board.
  // Reversed order left every star grey at load — the "color doesn't track"
  // bug.
  favouriteBoards.initBoardPage();
  favouriteBoards.initBoardsPage();
  favouriteBoards.initNavRemove();
  favouriteBoards.render();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', favouriteBoards.init);
} else {
  favouriteBoards.init();
}
